<don-thank-you
  [showMonthlyCta]="showMonthlyCta$ | async"
  [open]="true"
  [title]="title"
  [communityTitle]="communityTitle"
  [subtitle]="subtitle"
  [descriptionLines]="descriptionLines"
  [org]="org"
  [monthlyJoinForm]="monthlyJoinForm"
  (close)="onClose()"
  (joinMonthly)="onJoinMonthly()"
>
  <img
    illustration
    class="thank-you-illustration"
    src="assets/Image/icons-donate/_thanks.png"
    alt="Heart in hand"
  />

  <donation-summary-card
    summary
    [summary]="summary$ | async">
  </donation-summary-card>
</don-thank-you>